import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { seoExtLinkDetailLoad } from "store/models/seoExtLink";
import { DetailLoadComponent } from 'components/common';


const SeoExtLinkValue = (props) => {
  return (
    <DetailLoadComponent
      apiLoad={seoExtLinkDetailLoad}
      {...props}
      getDetailUrl={(id, item) => props.model.urls.detail(id)}
      render={({ id, item, linkPath }) => {
        const value = (item && item.url) || id;

        return (
          <Fragment>
            {props.asLink && linkPath ?
              <Link to={linkPath}>{value}</Link> :
              <span>{value}</span>}
          </Fragment>
        );
      }}
    />
  );
};

const mapState = state => ({
  router: state.router,
  authToken: state.auth.token,
  model: state.seoExtLink,
});

export default connect(mapState)(SeoExtLinkValue);
